module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile__tiers"
  }, [(!_vm.isVip) ? [_c('h5', [_vm._v("You can do it!")]), _vm._v(" "), _c('h5', {
    staticClass: "profile__tiers-copy"
  }, [_vm._v("Watch 15 movies to reach VIP Status.")])] : [_c('h5', [_vm._v("You did it!")]), _vm._v(" "), _c('h5', {
    staticClass: "profile__tiers-copy"
  }, [_vm._v("You have reached VIP Status.")])], _vm._v(" "), _c('div', {
    staticClass: "profile__tiers-circle"
  }, [_c('sk-progress-circular', {
    attrs: {
      "secondary": _vm.isVip,
      "primary": !_vm.isVip,
      "rotate": -90,
      "value": _vm.isVip ? 100 : _vm.percentage,
      "size": 230,
      "width": 20
    }
  }), _vm._v(" "), (!_vm.isVip) ? _c('h5', {
    staticClass: "profile__tiers-circle-copy"
  }, [_c('h1', {
    staticClass: "profile__tiers-circle-number"
  }, [_vm._v(_vm._s(_vm.toGo))]), _vm._v(" Movies to go")]) : _c('h1', {
    staticClass: "profile__tiers-circle-copy"
  }, [_vm._v("VIP")])], 1), _vm._v(" "), (!_vm.isVip) ? _c('h5', {
    staticClass: "profile__tiers-copy"
  }, [_vm._v(_vm._s(_vm.monthsLeft) + " Months left to watch")]) : _c('h5', {
    staticClass: "profile__tiers-copy"
  }, [_vm._v("Watch " + _vm._s(_vm.toGo < 0 && _vm.toGo > (-15) ? 15 + _vm.toGo : 15) + " movies in the next 12 months to stay on VIP.")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb03fc8c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/tiers/tiers.vue
// module id = 898
// module chunks = 0